import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
  BehaviorSubject,
  catchError,
  combineLatest,
  debounceTime, 
  filter, 
  Observable,
  of,
  Subject,
  switchMap,
  tap
} from "rxjs";
import _default from "chart.js/dist/plugins/plugin.tooltip";
import type = _default.defaults.animations.numbers.type;

@Injectable({
  providedIn: 'root'
})
export class SearchFormationService {
  private http = inject(HttpClient);
  public dataResult = new BehaviorSubject(null)
  public searchKeyworld = new BehaviorSubject('');
  public searchKeyworld$ = this.searchKeyworld.asObservable()
  public searchByAnswer = new BehaviorSubject(false);
  public searching = new BehaviorSubject(false);
  public searchCategory = new Subject();
  public checkedCategory = new BehaviorSubject('');
  public typeFormation = new BehaviorSubject<any[]>([])
  typeFormation$ = this.typeFormation.asObservable()
  public tags = new BehaviorSubject<any[]>([])
  public tags$ = this.tags.asObservable()
  // search$: Observable<any> = this.searchKeyworld$.pipe(
  //   tap((term) => {
  //     console.log('search term',term)
  //     console.log('filter :',(term.length > 2 || this.tags.value.length > 0))
  //   }),
  //   debounceTime(600),
  //   filter((term) => (term.length > 2 || this.tags.value.length > 0)),
  //   // distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
  //   tap(() => {
  //     console.log('search service called ');
  //     this.searching.next(true);
  //   })
  // );

  searchResult$: Observable<any> = combineLatest([
    this.tags$,
    this.searchKeyworld$
  ]).pipe(
    debounceTime(600),
    filter(( [ tags,term]) =>  (term.length > 2 || tags?.length > 0)),
    tap(() => {
      console.log('search service called ');
      this.searching.next(true);
    }),
    switchMap(([ tagss, term]) => {
      // const fomationType =typeFormation.map((dt)=>dt.label).join(',')
      const tags =tagss.map((dt)=>dt.id)
       return this.search({ search: term , tags,type:['catalogue','ressources'], answer: this.searchByAnswer.value }).pipe(
          catchError((err) => of(null)),
          tap(() => this.searching.next(false))
        )
      }
    ),
    tap(()=>{
      this.tags.next([])
      this.searchKeyworld.next('')
    })
  );
  public search(payload: any, limit = 0): Observable<any> {
    return this.http.post('/api/search/v1/get/search?limit=' + limit, payload);
  }

  checkKeyword(term: string) {
    return this.searchKeyworld.value === term;
  }
  getCheckedCategory() {
    return this.checkedCategory.value;
  }
  setCheckedCategory(category: string) {
    this.checkedCategory.next(category);
  }
}
